<template>
    <div class="card" id="coupon">
        <div class="card-body">
            <div class="divide-y">
                <div class="row">
                    <span class="col-4">
                        <label class="form-label">Купон</label>
                    </span>
                    <span class="col-8">
                        <input type="text" class="form-control" v-model="fields.coupon" placeholder="Купон" @change="onChange" />
                        <div v-if="v$.coupon.$invalid">
                            <span :class="{'is-invalid': v$.coupon.$invalid && v$.coupon.$dirty}"></span>
                            <div class="invalid-feedback" v-for="error of v$.coupon.$silentErrors" :key="error.$uid">
                                {{ error.$message }}
                            </div>
                        </div>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent, watch, onMounted, reactive} from "vue"
import {useVuelidate} from "@vuelidate/core/dist/index.esm"
import {minLength} from "@/plugins/vuelidator"

export default defineComponent({
    name: "Сoupon",
    props: {
        data: {
            type: [Object, null],
            default: null,
        },
    },
    setup(props, {emit}) {
        const fields = reactive({
            coupon: null,
        })

        onMounted(() => {
            fields.coupon = props.data.val;
        })

        watch(() => props.data.val, (val) => {
            fields.coupon = val
        })

        const rules = {
            coupon: {
                minLength: minLength(0),
            },
        }

        let $externalResults = reactive({})    

        const v$ = useVuelidate(rules, fields, {$externalResults})

        function validate(fn) {
            v$.value.$clearExternalResults()

            return v$.value.$validate().then(async () => {
                await fn()
            })
        }

        watch(() => props.data["validations"], (val) => {
            validate(() => {
                if (val?.coupon !== undefined) {
                    $externalResults.coupon = val["coupon"][0]
                }
            })
        })

        function onChange() {
            validate(() => {})
            emit("onChange", fields.coupon)
        }

        return {
            onChange,
            v$,
            fields,
        }
    }
})
</script>

<style scoped>

</style>
